"use client";

import { useTranslations } from "@i18n/next";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { openEmail } from "@packages/sdk";
import type { ButtonProps } from "@packages/ui";
import { Button } from "@packages/ui";

import { PAD_SUPPORT_EMAIL } from "../../../lib";

type ContactParishLeadButtonProps = Omit<ButtonProps, "variant" | "color"> & {
  emailOptions?: {
    body?: string;
    subject?: string;
  };
} & {
  size?: "s" | "m" | "l";
};

export const ContactParishLeadButton = ({
  emailOptions = {},
  ...props
}: ContactParishLeadButtonProps) => {
  const t = useTranslations();
  const analytics = useAnalytics();
  return (
    <Button
      size={"l"}
      variant="neutral"
      type="button"
      onClick={() => {
        analytics.track({
          event: HallowAnalyticsEvent.TappedContactHallowParishLead,
        });
        openEmail({ email: PAD_SUPPORT_EMAIL, ...emailOptions });
      }}
      {...props}
    >
      {t("contact_hallow_parish_lead")}
    </Button>
  );
};
